
(function () {
  var mq = window.matchMedia('(max-width: 760px)');

  function first(selectors, root) {
    root = root || document;
    for (var i = 0; i < selectors.length; i += 1) {
      var found = root.querySelector(selectors[i]);
      if (found) return found;
    }
    return null;
  }

  var gallerySelectors = [
    '.furnoc-product-detail__gallery', '.furnoc-product-gallery', '.furnoc-product-media',
    '.furnoc-product-visuals', '.furnoc-product-images', '.furnoc-product-detail__media',
    '.product__media-wrapper', '.product-gallery', '.product-media', '[data-product-gallery]',
    '[class*="product-gallery"]', '[class*="product-media"]'
  ];

  var infoSelectors = [
    '.furnoc-product-detail__info', '.furnoc-product-info', '.furnoc-product-summary',
    '.furnoc-product-summary-card', '.furnoc-product-buybox', '.furnoc-product-detail__content',
    '.furnoc-product-detail__side', '.product__info-wrapper', '.product__info-container',
    '[data-product-info]', '[class*="product-info"]', '[class*="product-summary"]',
    '[class*="buybox"]', '[class*="buy-box"]'
  ];

  function setImportant(el, prop, value) {
    // Use setProperty with 'important' priority so this fix can never be
    // silently overridden by a stylesheet !important rule (a plain
    // el.style.x = value assignment loses to any CSS !important rule,
    // which is exactly what was neutering this fix before).
    el.style.setProperty(prop, value, 'important');
  }

  function fixOverlap() {
    if (!mq.matches) return;
    var gallery = first(gallerySelectors);
    var info = first(infoSelectors);
    if (!gallery || !info || gallery === info || gallery.contains(info)) return;

    setImportant(info, 'position', 'relative');
    setImportant(info, 'z-index', '4');
    setImportant(info, 'inset', 'auto');
    setImportant(info, 'top', 'auto');
    setImportant(info, 'left', 'auto');
    setImportant(info, 'right', 'auto');
    setImportant(info, 'bottom', 'auto');
    setImportant(info, 'transform', 'none');
    setImportant(info, 'margin-left', '0px');
    setImportant(info, 'margin-right', '0px');
    setImportant(info, 'width', '100%');
    setImportant(info, 'max-width', 'none');
    setImportant(info, 'border-radius', '0px');
    setImportant(info, 'box-shadow', 'none');
    setImportant(info, 'background', '#fff');
    setImportant(info, 'margin-top', '0px');

    window.requestAnimationFrame(function () {
      var g = gallery.getBoundingClientRect();
      var i = info.getBoundingClientRect();
      var overlap = Math.ceil(g.bottom - i.top);
      // Clamp: the CSS layout (furnoc-ikea-system-mobile.css) now owns the
      // real fix and should produce ~0 overlap on its own. This JS is only
      // a small safety net for genuine sub-pixel/rounding gaps. Capping the
      // correction to 32px means a bogus getBoundingClientRect() reading
      // (e.g. taken mid-reflow before layout has settled) can never punch a
      // large permanent gap between the gallery and info panel the way an
      // uncapped, !important-forced margin could.
      if (overlap > 0 && overlap < 120) {
        var corrected = Math.min(overlap + 18, 32);
        setImportant(info, 'margin-top', corrected + 'px');
      }
    });
  }

  function run() {
    fixOverlap();
  }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', function () { run(); setTimeout(run, 250); setTimeout(run, 900); });
  window.addEventListener('resize', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('variant:change', function () { setTimeout(run, 50); });
})();
